export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-panel/index.js